import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="23962" id="hero-introduction" className="relative w-full overflow-hidden bg-background py-[120px]">
      {}
      <div className="pointer-events-none absolute -top-20 -right-20 h-[600px] w-[600px] rounded-full bg-muted/30 blur-[120px] opacity-60 mix-blend-multiply" />

      <div ref={ref} className={cn("container relative mx-auto flex flex-col items-center px-4 text-center transition-all duration-[400ms] ease-[cubic-bezier(0.4,0,0.2,1)]", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        {}
        <h1 className="max-w-5xl font-sans text-[48px] font-extrabold uppercase leading-[1.1] tracking-normal text-foreground md:text-[72px]">
          Architectural Precision In Every Build
        </h1>

        {}
        <p className="mt-6 max-w-2xl font-sans text-[20px] font-medium leading-[1.6] text-muted-foreground">
          Defining the standard of clinical authority in structural design.
        </p>

        {}
        <div className="mt-10 flex flex-col items-center gap-4 sm:w-auto">
          <Button asChild className="h-auto min-w-[240px] rounded-[6px] bg-primary px-8 py-4 text-lg font-medium text-primary-foreground shadow-[inset_0_1px_0_0_rgba(255,255,255,0.2)] transition-all hover:scale-105 hover:shadow-lg hover:brightness-110 border-none">
            <Link to="/HomePage">GET STARTED</Link>
          </Button>

          <Button asChild variant="outline" className="h-auto min-w-[240px] rounded-[6px] border-2 border-foreground bg-transparent px-8 py-4 text-lg font-medium text-foreground backdrop-blur-sm transition-all hover:bg-muted/20">
            <Link to="#">LEARN MORE</Link>
          </Button>
        </div>
      </div>
    </section>;
}